import React from "react";
import DockyardFormContent from "./components/DockyardFormContent";
import { DockyardFormProvider } from "./context/DockyardFormContext";
import { DockyardFormProps } from "./types";

const DockyardForm: React.FC<DockyardFormProps> = ({
  onSubmit,
  onCancel,
  dockyard,
  error,
  isSubmitting = false,
  defaultValuesForm = {},
}) => {
  return (
    <DockyardFormProvider
      dockyard={dockyard}
      isSubmitting={isSubmitting}
      error={error}
      defaultValuesForm={defaultValuesForm}
    >
      <DockyardFormContent onSubmit={onSubmit} onCancel={onCancel} />
    </DockyardFormProvider>
  );
};

export default DockyardForm;
